import { afterNextRender, Component, Inject, OnDestroy, OnInit, DOCUMENT } from '@angular/core';
import { UserAccount } from '../../../entity/UserAccount';
import { RouterLink } from '@angular/router';
import { UIPopoverContent, UIPopoverRef } from '@irohalab/deneb-ui';
import { fromEvent, Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';


@Component({
    selector: 'app-user-action-panel',
    imports: [
    RouterLink
],
    templateUrl: './user-action-panel.component.html',
  styleUrl: './user-action-panel.component.less'
})
export class UserActionPanelComponent extends UIPopoverContent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  user!: UserAccount;

  adminUrl: string = environment.adminUIBasePath;

  get showAdminURL(): boolean {
    return this.user ? (this.user.type === 'Admin' || this.user.type === 'SuperAdmin') : false;
  }

  constructor(popoverRef: UIPopoverRef<UserActionPanelComponent>,
              @Inject(DOCUMENT) private document: Document,) {
    super(popoverRef);
    afterNextRender(() => {
      this.subscription.add(
        fromEvent(document.body, 'click')
          .subscribe(() => {
            this.popoverRef.close(null);
          })
      );
    })
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
  }

  logout(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.popoverRef.close('logout');
  }

  close(): void {
    this.popoverRef.close(null);
  }
}
